import React from "react";
import bg from "../../Assets/Contact/bg.png";

const Map = () => {
  return (
    <React.Fragment>
      <div>
        <div className="w-full h-80 lg:h-[500px] mt-10 px-6 md:px-16">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29926.806279121905!2d85.93351558820514!3d20.347782049161644!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19757ea09a7a97%3A0x44443faeb70fdc9b!2sDEB%20Online%20Shopping%20Store%20-%20Vegetables%2C%20Grocery%2C%20Food%20%26%20Restaurant%20in%20Grand%20Bazaar%2C%20Nakhara%2C%20Cuttack%20%26%20Bhubaneswar!5e0!3m2!1sen!2sin!4v1750139004825!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          />
        </div>
      </div>
      <img src={bg} alt="bg" />
    </React.Fragment>
  );
};

export default Map;
